import React, {useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {setBetting} from 'virtual_congress/exhibition_actions'
import axios from 'axios';
import classNames from 'classnames'

const BetOption = ({option, betId, customProps, children}) => {
  const dispatch = useDispatch()

  const [sending, setSending] = useState(false)

  const tagOwner = useSelector((state) => state.tagOwner)
  let bettingsUrl = useSelector((state) => state.bettingsUrl)
  bettingsUrl = bettingsUrl?.replace("@tag_owner_id@", tagOwner.id)
  const bets = useSelector(state => state.bets)
  const bettings = useSelector(state => state.bettings)

  const bet = bets ? Object.values(bets).find((bet) => bet.id == betId) : null
  const betting = bettings?.find((betting) => betting.bet_id == bet.id)

  if (!bet) {
    return <div className={"alert alert-danger"}>
      No bet with id {betId} found.
    </div>
  }

  const hasVoted = !!betting
  const disabled = sending || hasVoted || bet.show_results
  const isSelected = option == betting?.bet_option_id
  const isCorrect = hasVoted && bet[`bet_option_${option}_correct`]
  const isIncorrect = hasVoted && betting?.bet_option_id == option && !bet[`bet_option_${option}_correct`]

  const submit = () => {
    if (sending) {
      return
    }

    setSending(true)
    const data = {
      bet_id: bet.id,
      bet_option_id: option,
      betting: {
        bet_option_id: option,
        bet_option_1_value: 0,
        bet_option_2_value: 0,
        bet_option_3_value: 0,
        bet_option_4_value: 0,
      }
    }

    data.betting[`bet_option_${option}_value`] = 1

    axios.put(bettingsUrl.replace("@id@", bet.id), data).then(response => {
        if (response.data.status === "OK") {
          dispatch(setBetting(response.data.betting))
        } else {
          alert(response)
        }
      },
      error => {
        alert(error)
        console.error(error)
        setSending(false)
      })
  }

  customProps ||= {}
  customProps.className ||= ""
  customProps.className += " "
  customProps.className += classNames("bet-answer", {
    disabled: disabled,
    selected: isSelected,
    correct: isCorrect,
    incorrect: isIncorrect,
  })

  return <div
    {...customProps}
    onClick={() => !disabled && submit(option)}
  >
    {children}
  </div>
}

export default BetOption

